/** "Lo hago después", remembered per company in this browser so the tour does not come back each visit. */
export const welcomeSkipKey = (tenantId: string) => `orbis.welcome.skipped.${tenantId}`;
